export const inputHelpers = {
    methods: {
        /**
         * On tooltip item mouse over
         * @param description
         * @param isRequired
         */
        formattedLabel(description, isRequired) {
            const requiredText = isRequired
                ? `*`
                : '';
            return `${requiredText} ${description}`;
        },
        /**
         * On tooltip item mouse over
         * @param description
         * @param isRequired
         */
        formattedAriaLabel(description, isRequired) {
            const requiredText = isRequired
                ? `(${this.$t('form.required')})`
                : `(${this.$t('form.optional')})`;
            return `${requiredText}: ${description}`;
        },
        formattedAriaLabelForSelectBoxWithDescription(description, isRequired, multiple) {
            const fullDescription = description + '. ' + this.$t(`appt.accessibility.dropdown`) + (multiple ? this.$t('appt.accessibility.dropdownMultiple') : '');
            const result = this.formattedAriaLabel(fullDescription, isRequired);

            return result;
        },
        formattedAriaLabelForSelectBox(description, isRequired, currentValueText) {
            const haveCurrentValue = currentValueText && typeof currentValueText === 'string' && currentValueText !== '';
            const currentTextValue = haveCurrentValue ? ' Option : ' + currentValueText + ' ' + this.$t(`base.selected`) : '';
            const fullDescription = description + currentTextValue;
            const result = this.formattedAriaLabel(fullDescription, isRequired);

            return result;
        }
    },
};
